/* @ngInject */
function SharedPackItemController ($q, $scope, $state, $window, UdsModalService, RepositoryService) {
  const getUpdateAccessExpirationDateDialogController = () => {
    return $q.when(import('../../dialogs/update-access-expiration-date/update-access-expiration-date-dialog.controller'))
  }
  const getDeleteAssetPackDialogController = () => {
    return $q.when(import('../../dialogs/delete-asset-pack/delete-asset-pack-dialog.controller'))
  }

  const getAssetPackAccessDialogController = () => {
    return $q.when(import('../../dialogs/asset-pack-access/asset-pack-access-dialog.controller'))
  }

  const ctrl = this

  ctrl.openSharedPack = function (newTab) {
    if (newTab) {
      const url = $state.href('assetPack.assetPackSummary', { assetPackId: ctrl.packItem.id })
      $window.open(url, '_blank')
    } else {
      $state.go('assetPack.assetPackSummary', { assetPackId: ctrl.packItem.id })
    }
  }

  ctrl.handleDownloadAll = () => {
    $state.go('assetPack.assetPackDownloadAll', { assetPackId: ctrl.packItem.id })
  }

  ctrl.openUpdateAccessExpirationDateDialog = function () {
    getUpdateAccessExpirationDateDialogController().then(({ UpdateAccessExpirationDateDialogController }) => {
      const updateAccessExpirationDateDialog = UdsModalService.createModal({
        controller: UpdateAccessExpirationDateDialogController,
        modalName: 'updateAccessExpirationDateDialog',
        data: {
          item: ctrl.packItem,
          onChangeSuccess: function () {
            ctrl.onItemUpdate()
          }
        }
      })
      updateAccessExpirationDateDialog.open()
    })
  }

  ctrl.openDeleteAssetPackDialog = function () {
    getDeleteAssetPackDialogController().then(({ DeleteAssetPackDialogController }) => {
      const deleteAssetPackDialog = UdsModalService.createModal({
        controller: DeleteAssetPackDialogController,
        modalName: 'deleteAssetPackDialog',
        data: {
          assetPackId: ctrl.packItem.id,
          onChangeSuccess: function () {
            ctrl.onItemUpdate()
          }
        }
      })
      deleteAssetPackDialog.open()
    })
  }

  ctrl.openAssetPackAccessModal = () => {
    getAssetPackAccessDialogController().then(({ AssetPackAccessDialogController }) => {
      const assetPackAccessDialog = UdsModalService.createModal({
        controller: AssetPackAccessDialogController,
        modalName: 'assetPackAccess',
        data: {
          assetPackId: ctrl.packItem.id,
          onChangeSuccess: function () {
            ctrl.onItemUpdate()
          }
        }
      })
      assetPackAccessDialog.open()
    })
  }
}

export { SharedPackItemController }
